import { forwardRef, HTMLProps, useState } from 'react'
import clsx from 'clsx'

type CheckboxProps = HTMLProps<HTMLInputElement>

interface CheckboxToggleProps extends CheckboxProps {
  onToggle: (isChecked: boolean) => void;
}

const CheckboxToggle = forwardRef<HTMLInputElement, CheckboxToggleProps>(
  ({ className, label, id, defaultChecked, value, onToggle, ...rest }, ref) => {
    const [isCheck, setIsCheck] = useState<boolean | undefined>(defaultChecked);

    const handleToggle = () => {
      const newState = !isCheck;
      setIsCheck(newState);
      setTimeout(() => {
        onToggle(newState);
      }, 100);
    }

    return (
      <div className={`${className ? className : "mb-4 w-52 p-6"}`}>
        <label htmlFor={id} data-content={label} className="font-semibold text-sm">
          {label}
        </label>
        <div onClick={handleToggle} className="relative">
          <input
            id={id}
            className="absolute w-10 h-8 opacity-0 z-50 cursor-pointer"
            type="checkbox"
            defaultChecked={defaultChecked}
            ref={ref}
            value={value}
            {...rest}
          />
        </div>
        <div className={
          clsx('w-11 h-6 mt-2 bg-gray-300 rounded-full p-1 transition duration-150 ease-in-out',
            { 'bg-green-500': isCheck })}>
          <div className={
            clsx(`transform w-4 h-4 bg-white rounded-full shadow-md transition duration-150 ease-in-out`, 
            { 'translate-x-5': isCheck })}></div>
        </div>
      </div>
    );
  }
);

export default CheckboxToggle;
